import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBDataTable } from "mdbreact";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Table,
  CardTitle,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import moment from "moment";
import $ from "jquery";
import axios from "axios";
import {
  getDate,
  getFirstday,
} from "../../../helpers/globalFunctions";
import accessToken from "../../../helpers/jwt-token-access/accessToken";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import "./shortlistedApplication.scss";
import toastr from "toastr";
import Pagination from "@mui/material/Pagination";
//import ReactPlayer from "react-player";

import useSearchValue from "../../../hooks/useSearchValue";
import CircularProgress from "@mui/material/CircularProgress"

const ShortlistedApplication = (props) => {
  const [searchData, setSearchData] = useState({
    // from_date: getDate(new Date()),
    // to_date: getDate(new Date()),
  });
  const [details, setDetails] = useState([]);
  const [popupView, setPopupView] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [instituteOptions, setInstituteOptions] = useState([]);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [candidateOptions, setCandidateOptions] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [jobpostOptions, setJobpostOptions] = useState([]);
  const [selectedJobpost, setSelectedJobpost] = useState(null);
  const [showDeclineForm, setShowDeclineForm] = useState(false);
  const [selectedSourse, setselectedSourse] = useState(null)

  const [master, setMaster] = useState({});
  const [errors, setErrors] = useState({
    remarkError: "",
  });
  const [selectedDecline, setSelectedDecline] = useState(null);
  const [ReasonsOption, setReasonsOptions] = useState([]);
  const [videoForm, setVideoForm] = useState(false);
  // const [candidateVideo, setCandidateVideo] = useState({});
  const [candidateVideo1, setCandidateVideo1] = useState("");
  const [candidateVideo2, setCandidateVideo2] = useState("");
  const [candidateVideo1Hash, setCandidateVideo1Hash] = React.useState("");
  const [candidateVideo2Hash, setCandidateVideo2Hash] = React.useState("");
  const API_URL = process.env.REACT_APP_APIURL || "http://localhost:3099/";

  /** pagination */
  const [searchValue, setSearchValue] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [PerPageCount, setPerPageCount] = useState(20);
  const [indexOfLastTransfer, setindexOfLastTransfer] = useState(
    currentPage * PerPageCount
  );
  const [indexOfFirstTransfer, setindexOfFirstTransfer] = useState(
    indexOfLastTransfer - PerPageCount
  );



  const [keyword, setKeyword] = useState(null)

  const [isLoading, setIsLoading] = useState(false)

  const deferredKeyword = useSearchValue(keyword, 500)


  useEffect(() => {
    if (deferredKeyword !== null) {
      handleSearch(deferredKeyword)
    }
  }, [deferredKeyword])


  const paginate = (event, value) => {
    setCurrentPage(value);
    const indexOfLastTransfer = value * PerPageCount;
    const indexOfFirstTransfer = indexOfLastTransfer - PerPageCount;
    setindexOfFirstTransfer(indexOfFirstTransfer);
    setindexOfLastTransfer(indexOfLastTransfer);
    handleTableData(searchValue, searchData?.from_date, searchData?.to_date, selectedCandidate?.value, selectedJobpost?.value, selectedInstitute?.value,searchData?.findresume, value, PerPageCount);
  };
  const resetPaginate = () => {
    setCurrentPage(1);
    const indexOfLastTransfer = 20;
    const indexOfFirstTransfer = 0;
    setindexOfFirstTransfer(indexOfFirstTransfer);
    setindexOfLastTransfer(indexOfLastTransfer);
  }
  const handleSearch = (value) => {
    setSearchValue(value)
    resetPaginate();
    handleTableData(value, searchData?.from_date, searchData?.to_date, selectedCandidate?.value, selectedJobpost?.value, selectedInstitute?.value,searchData?.findresume);
  }
  useEffect(() => {
    if (details.length == 0 && indexOfFirstTransfer != 0) {
      resetPaginate();
      handleTableData(searchValue, searchData?.from_date, searchData?.to_date, selectedCandidate?.value, selectedJobpost?.value, selectedInstitute?.value,searchData?.findresume);
    }
  }, [])
  /** end pagination */

  useEffect(() => {
    handleTableData(searchValue);
    fetch_all_institute();
    fetch_candidate();
    fetch_all_reasons();
  }, []);
  const fetch_all_reasons = () => {
    axios
      .get(`${API_URL}manage/decline`, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let reason_data =
          res.data.data &&
          res.data.data.map((item) => {
            return {
              label: item?.remark,
              value: item?._id,
            };
          });
        setReasonsOptions([
          {
            options: reason_data,
          },
        ]);
      });
  };
  function handleTableData(
    search = "",
    fromDate = "",
    toDate = "",
    candidate_id = "",
    job_id = "",
    institute_id = "",
    findresume="",
    start = 1, end = 20
  ) {
    setIsLoading(true)
    var url = `${API_URL}shortlist/list`;
    if (fromDate === "" && toDate === "") {
      // fromDate = fromDate ? fromDate : getDate(new Date());
      // toDate = toDate ? toDate : getDate(new Date());
    }
    url =
      url +
      "?from_date=" +
      fromDate +
      "&to_date=" +
      toDate +
      "&candidate_id=" +
      candidate_id +
      "&job_id=" +
      job_id +
      "&institute_id=" +
      institute_id + "&findresume="+findresume+ "&search=" + search + "&start=" + start + "&end=" + end;

    axios
      .get(url, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let result = res.data.data;
        setTotalPages(res.data.limit);
        var id = (start - 1) * end;
        result &&
          result.map((item, index) => {
            id++;
            item.id = id;
            item.date = moment(item?.shortlisted_date).format("DD-MM-YYYY");
            item.time = moment(item?.shortlisted_time, "hhmmss").format(
              "hh:mm a"
            );
            item.interviewdate = moment(
              item?.shortlisted_interview_date
            ).format("DD-MM-YYYY");
            if (item?.shortlisted_current_status === 0)
              item.status = "Shortlisted";
            else if (item?.shortlisted_current_status === 1)
              item.status = "Placed";
            else if (item?.shortlisted_current_status === 2)
              item.status = "Declined";
            else item.status = "";

            item.jobName =
              item?.shortlisted_job_name ? item?.shortlisted_job_name + " " + "(" + item?.job_reg_no + ")" : "Shortlisted via resume";
            item.reg_no =
              item?.shortlisted_reg_no ? item?.shortlisted_reg_no : "Shortlisted via resume";

            item.instName = (
              <div>
                {item?.shortlisted_inst_name ? (
                  <a
                    target="blank"
                    style={{ cursor: "pointer" }}
                    href={"/institute/" + item?.inst_reg_no}
                  >
                    {item?.shortlisted_inst_name}
                  </a>
                ) : "Shortlisted via resume"}
              </div>
            )

            item.action = (
              <div>
                <button
                  className="button_class"
                  onClick={() => {
                    handleClickOpenForm(item);
                  }}
                >
                  <i className="fas fa-eye"></i>
                </button>
                <button
                  onClick={() => {
                    openVideoForm(item);
                  }}
                  className="button_class"
                >
                  <i className="fas fa-video"></i>
                </button>
                <button
                  onClick={() => {
                    openDeclineForm(item);
                  }}
                  className="button_class"
                >
                  <i className="fas fa-thumbs-down"></i>
                </button>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id="button-tooltip-2"
                      style={{ position: "absolute", top: "-30px" }}
                    >
                      Place Application
                    </Tooltip>
                  }
                >
                  <button
                    className="button_class"
                    onClick={() => {
                      placeApplication(item, search, fromDate, toDate, candidate_id, job_id, institute_id, start, end);
                    }}
                  >
                    <i className="fas fa-user-check"></i>
                  </button>
                </OverlayTrigger>
              </div>
            );
          });
        setDetails(result);
      }).finally(() => {
        setIsLoading(false)
      });
  }
  const openVideoForm = (item) => {
    axios
      .get(
        `${API_URL}candidate/file?candidate_id=` + item.shortlisted_cand_id,
        {
          headers: {
            "x-access-token": accessToken,
          },
        }
      )
      .then((res) => {
        let result = res.data.data;
        if (result?.cand_video1 || result?.cand_video2) {
          if (result?.cand_video1) {
            let vdo = result.cand_video1.split("/");
            let data1 = vdo.slice(-1).pop();
            let data = vdo.at(-2);
            setCandidateVideo1(data);
            setCandidateVideo1Hash(data1);
          } else {
            setCandidateVideo1("");
            setCandidateVideo1Hash("");
          }
          if (result?.cand_video2) {
            let vdo2 = result?.cand_video2.split("/");
            let value2 = vdo2.slice(-1).pop();
            let value = vdo2.at(-2);
            setCandidateVideo2(value);
            setCandidateVideo2Hash(value2);
          } else {
            setCandidateVideo2("");
            setCandidateVideo2Hash("");
          }
          setVideoForm(true);
        } else {
          toastr.error("No video is available");
          setCandidateVideo1("");
          setCandidateVideo2("");
          setCandidateVideo1Hash("");
          setCandidateVideo2Hash("");
        }
      });
  };
  const openDeclineForm = (item) => {
    if (item?.shortlisted_current_status === 2) {
      toastr.error("Application is already declined");
    } else {
      setSelectedDecline(null);
      setMaster({
        shortlist_id: item?._id,
      });
      setErrors({
        remarkError: "",
      });
      setShowDeclineForm(true);
    }
  };
  const placeApplication = (item, search, fromDate, toDate, candidate_id, job_id, institute_id, start, end) => {
    if (item?.shortlisted_current_status === 1) {
      toastr.error("Application is already placed");
    } else if (item?.shortlisted_current_status === 2) {
      toastr.error("Can't place declined application");
    } else {
      let data = {
        application_id: item?.application_id,
      };
      axios
        .post(`${API_URL}placed/`, data, {
          headers: {
            "x-access-token": accessToken,
          },
        })
        .then((res) => {
          if (res.data.status === 200) {
            toastr.success("Application is placed");
            handleTableData(search, fromDate, toDate, candidate_id, job_id, institute_id, start, end);
          }
        })
        .catch((err) => {
          toastr.error(err.response.data.message);
          return;
        });
    }
  };
  const fetch_all_institute = () => {
    axios
      .get(`${API_URL}institute/options`, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let institute_data =
          res.data.data &&
          res.data.data.map((el) => {
            return {
              label: el?.inst_reg_no + "-" + el?.inst_name,
              value: el?._id,
            };
          });
        setInstituteOptions([
          {
            options: institute_data,
          },
        ]);
      });
  };
  const fetch_all_jobpost = (id) => {
    axios
      .get(`${API_URL}institute/jobname?institute_id=` + id, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let job_data =
          res.data.data &&
          res.data.data.map((el) => {
            return {
              label: el?.job_name,
              value: el?._id,
            };
          });
        setJobpostOptions([
          {
            options: job_data,
          },
        ]);
      });
  };
  const fetch_candidate = () => {
    axios
      .get(`${API_URL}candidate/options`, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let candidate_data =
          res.data.data &&
          res.data.data.map((el) => {
            return {
              label: el?.cand_name,
              value: el?._id,
            };
          });
        setCandidateOptions([
          {
            options: candidate_data,
          },
        ]);
      });
  };
  const handleClickOpenForm = (item) => {
    axios
      .get(`${API_URL}shortlist/view?shortlisted_id=` + item?._id, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let result = res.data.data;
        result.date = moment(result?.shortlisted_date).format("DD-MM-YYYY");
        result.time = moment(result?.shortlisted_time, "hhmmss").format(
          "hh:mm a"
        );

        let jobDetails = result.job_details || {};
        result.district = jobDetails?.job_district;
        result.state = jobDetails?.job_state;
        // result.subject = jobDetails?.job_subject;
        result.exp = jobDetails?.job_experience;
        result.qualification = jobDetails?.job_qualification;
        // jobDetails.job_qualification &&
        //   jobDetails.job_qualification.map((el) => {
        //     if (result.qualification === "") result.qualification = el;
        //     else result.qualification = result.qualification + "," + el;
        //   });
        setPopupData(result);
        setPopupView(true);
      });
  };
  let handleDate = (e) => {
    if (e.target.name == "from_date") {
      var date1 = e.target.value;
      var date2 = searchData?.to_date;
    }
    else {
      var date1 = searchData?.from_date;
      var date2 = e.target.value;
    }

    let candidate_id = searchData?.candidate_id ? searchData.candidate_id : "";
    let job_id = searchData?.job_id ? searchData.job_id : "";
    let institute_id = searchData?.institute_id ? searchData.institute_id : "";
    let toDate = moment(date1);
    let fromDate = moment(date2);
    let result = fromDate.diff(toDate, "days");
    resetPaginate();

    if (result + 1 <= 0) {
      setSearchData({
        ...searchData,
        [e.target.name]: e.target.value,
        ["to_date"]: "",
      });
      date2 = "";
    } else {
      setSearchData({
        ...searchData,
        [e.target.name]: e.target.value,
      });
    }
    handleTableData(searchValue, date1, date2, candidate_id, job_id, institute_id);
  };
  const reset = () => {
    setSearchData({
      // from_date: getDate(new Date()),
      // to_date: getDate(new Date()),
    });
    setSelectedCandidate(null);
    setSelectedInstitute(null);
    setSelectedJobpost(null);
    setJobpostOptions([]);
    handleTableData(searchValue);
    resetPaginate();
  };

  const data = {
    columns: [
      {
        label: "#",
        field: "id",
        sort: "asc",
        width: 100,
      },
      {
        label: "Date",
        field: "date",
        sort: "asc",
        width: 400,
      },
      // {
      //   label: "Time",
      //   field: "time",
      //   sort: "asc",
      //   width: 200,
      // },
      {
        label: "Shortlisted ID",
        field: "reg_no",
        sort: "asc",
        width: 200,
      },
      // {
      //   label: "Application ID",
      //   field: "application_id",
      //   sort: "asc",
      //   width: 200,
      // },
      {
        label: "Job Name",
        field: "jobName",
        sort: "asc",
        width: 200,
      },
      {
        label: "Institute",
        field: "instName",
        sort: "asc",
        width: 200,
      },
      {
        label: "Applicant",
        field: "shortlisted_cand_name",
        sort: "asc",
        width: 200,
      },
      {
        label: "Mobile",
        field: "shortlisted_cand_mob",
        sort: "asc",
        width: 200,
      },
   
      {
        label: "Status",
        field: "status",
        sort: "asc",
        width: 150,
      },
      {
        label: "Action",
        field: "action",
        sort: "asc",
        width: 150,
      },
    ],
    rows: details,
  };
  const handleSelectChange = (selected, name) => {
    let fromDate = searchData?.from_date ? searchData.from_date : "";
    let toDate = searchData?.to_date ? searchData.to_date : "";
    let candidate_id = searchData?.candidate_id ? searchData.candidate_id : "";
    let job_id = searchData?.job_id ? searchData.job_id : "";
    let institute_id = searchData?.institute_id ? searchData.institute_id : "";
    let findresume = searchData?.findresume ? searchData.findresume : "";
    if (name != "reason")
      resetPaginate();
    switch (name) {
      case "institute":
        setSelectedInstitute(selected);
        setSelectedJobpost(null);
        setSearchData({
          ...searchData,
          institute_id: selected.value,
          job_id: "",
        });
        fetch_all_jobpost(selected.value);
        handleTableData(searchValue, fromDate, toDate, candidate_id, "", selected.value, findresume);
        break;
      case "jobPost":
        setSelectedJobpost(selected);
        setSearchData({
          ...searchData,
          job_id: selected.value,
        });
        handleTableData(
          searchValue,
          fromDate,
          toDate,
          candidate_id,
          selected.value,
          institute_id, findresume
        );
        break;
      case "candidate":
        setSelectedCandidate(selected);
        setSearchData({
          ...searchData,
          candidate_id: selected.value,
        });
        handleTableData(searchValue, fromDate, toDate, selected.value, job_id, institute_id, findresume);
        break;
      case "reason":
        setSelectedDecline(selected);
        setMaster({
          ...master,
          decline_remark: selected.label,
        });
        setErrors({
          remarkError: "",
        });
        break;
      case "findresume":
        setselectedSourse(selected)
        setSearchData({ ...searchData, findresume: selected.value })
        handleTableData(searchValue, fromDate, toDate, candidate_id, job_id, institute_id, selected.value);
        break;
      default:
        break;
    }
  };

  const submitDeclineForm = () => {
    if (selectedDecline === null) {
      setErrors({
        remarkError: "Please select the reason",
      });
    } else {
      axios
        .put(
          `${API_URL}shortlist/decline?shortlist_id=` + master?.shortlist_id,
          master,
          {
            headers: {
              "x-access-token": accessToken,
            },
          }
        )
        .then((res) => {
          if (res.data.status === 200) {
            toastr.success("Application declined successfully");
            setSelectedDecline(null);
            handleTableData(searchValue, searchData?.from_date, searchData?.to_date, selectedCandidate?.value, selectedJobpost?.value, selectedInstitute?.value, indexOfFirstTransfer, indexOfLastTransfer);
            setMaster({});
            setShowDeclineForm(false);
          } else {
            toastr.error("Failed to decline application");
          }
        })
        .catch((err) => {
          toastr.error(err.response.data.message);
          return;
        });
    }
  };


  return (
    <React.Fragment>
      <Modal show={videoForm} size="lg" centered={true}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Candidate Videos</h5>
          <button
            type="button"
            onClick={() => {
              setVideoForm(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <AvForm className="needs-validation" onValidSubmit={(e, v) => { }}>
          <div className="modal-body">
            <Row>
              <Col xl={6}>
                <Card>
                  <CardBody>
                    <CardTitle className="h4">Intro video</CardTitle>
                    <p className="card-title-desc"></p>

                    <div className="embed-responsive embed-responsive-16by9 ratio ratio-16x9">
                      {candidateVideo1 && (
                        <iframe
                          title="test"
                          className="embed-responsive-item"
                          src={`https://player.vimeo.com/video/${candidateVideo1}?h=${candidateVideo1Hash}`}
                          frameBorder={0}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        />
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xl={6}>
                <Card>
                  <CardBody>
                    <CardTitle className="h4">Teaching video</CardTitle>
                    <p className="card-title-desc"></p>

                    <div className="embed-responsive embed-responsive-16by9 ratio ratio-16x9">
                      {candidateVideo2 && (
                        <iframe
                          title="test"
                          className="embed-responsive-item"
                          src={`https://player.vimeo.com/video/${candidateVideo2}?h=${candidateVideo2Hash}`}
                          frameBorder={0}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        />
                      )}
                    </div>
                  </CardBody>
                </Card>
                {/* <Card>
                  <CardBody>
                    <div>
                      <Row>
                        <ReactPlayer url={candidateVideo?.cand_video2} />
                      </Row>
                    </div>
                  </CardBody>
                </Card> */}
              </Col>
            </Row>
          </div>
        </AvForm>
      </Modal>
      <Modal show={popupView} size="lg" centered={true}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Shortlisted Details </h5>
          <button
            type="button"
            onClick={() => {
              setPopupView(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <AvForm className="needs-validation" onValidSubmit={(e, v) => { }}>
          <div className="modal-body">
            <table
              id="product_available_day"
              className="table table-bordered dataTable"
            >
              <tr>
                <td style={{ width: "184px", padding: "10px" }}>
                  Application Name :
                </td>
                <td>{popupData?.shortlisted_job_name ? popupData?.shortlisted_job_name : "Shortlisted via resume"}</td>
                <td style={{ paddingLeft: "25px" }}>Shortlisted ID :</td>
                <td style={{ textAlign: "left" }}>
                  {popupData?.shortlisted_reg_no ? popupData?.shortlisted_reg_no : "Shortlisted via resume"}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>Shortlisted Date :</td>
                <td>{popupData?.date ? popupData?.date : "Shortlisted via resume"}</td>
                <td style={{ paddingLeft: "25px" }}>Shortlisted Time :</td>
                <td style={{ textAlign: "left" }}>{popupData?.time ? popupData?.time : "Shortlisted via resume"}</td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>State :</td>
                <td>{popupData?.state ? popupData?.state : "Shortlisted via resume"}</td>
                <td style={{ paddingLeft: "25px" }}>District :</td>
                <td style={{ textAlign: "left" }}>{popupData?.district ? popupData?.district : "Shortlisted via resume"}</td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>Institute :</td>
                <td style={{ width: "200px", wordBreak: "break-all" }}>
                  {popupData?.shortlisted_inst_name ? popupData?.shortlisted_inst_name : "Shortlisted via resume"}
                </td>
                <td style={{ paddingLeft: "25px" }}>Candidate :</td>
                <td style={{ textAlign: "left" }}>
                  {popupData?.shortlisted_cand_name ? popupData?.shortlisted_cand_name : "Shortlisted via resume"}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>Experience :</td>
                <td>{popupData?.exp ? popupData?.exp : "Shortlisted via resume"}</td>
                <td style={{ paddingLeft: "25px" }}>Qualification :</td>
                <td
                  style={{
                    textAlign: "left",
                    width: "189.97px",
                    wordBreak: "break-all",
                  }}
                >
                  {popupData?.qualification ? popupData?.qualification : "Shortlisted via resume"}
                </td>
              </tr>
              <tr hidden={popupData?.shortlisted_current_status !== 2}>
                <td style={{ padding: "10px" }}>Status :</td>
                <td>{"Declined"}</td>
                <td style={{ paddingLeft: "25px" }}>Remarks :</td>
                <td
                  style={{
                    textAlign: "left",
                    width: "189.97px",
                    wordBreak: "break-all",
                  }}
                >
                  {popupData?.decline_remark ? popupData?.decline_remark : "Shortlisted via resume"}
                </td>
              </tr>
            </table>
          </div>
        </AvForm>
      </Modal>
      <Modal show={showDeclineForm} size="md" centered={true}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Decline Candidate</h5>
          <button
            type="button"
            onClick={() => {
              setShowDeclineForm(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <AvForm
          className="needs-validation"
          onValidSubmit={() => {
            submitDeclineForm();
          }}
        >
          <div className="modal-body">
            <Row>
              <Col md="12">
                <div className="mb-3">
                  <Label>Reason</Label>
                  <Select
                    name="decline_remark"
                    value={selectedDecline}
                    onChange={(selected) => {
                      handleSelectChange(selected, "reason");
                    }}
                    options={ReasonsOption}
                    classNamePrefix="select2-selection"
                  />
                  <p className="text-danger" style={{ fontSize: "11px" }}>
                    {selectedDecline === null ? errors.remarkError : ""}
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="row mb-0">
              <Col className="col-12 text-end">
                <Button
                  color="primary"
                  type="submit"
                  style={{ float: "right" }}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </div>
        </AvForm>
      </Modal>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Shortlisted Applications" />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  {isLoading && (
                    <div className="d-flex justify-content-end me-4">
                      <CircularProgress size={30} />
                    </div>
                  )}
                  <AvForm>
                    <Row>
                      <Col md="2">
                        <div className="mb-3">
                          <Label htmlFor="validationCustom05">From</Label>
                          <input
                            className="form-control"
                            type="date"
                            id="from_date"
                            name="from_date"
                            value={searchData?.from_date}
                            onChange={handleDate}
                          />
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="mb-3">
                          <Label htmlFor="validationCustom05">To</Label>
                          <input
                            className="form-control"
                            type="date"
                            id="to_date"
                            name="to_date"
                            value={searchData?.to_date}
                            onChange={handleDate}
                            min={searchData?.from_date}
                          />
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="mb-3">
                          <Label>Institute</Label>
                          <Select
                            name="institute"
                            value={selectedInstitute}
                            onChange={(selected) => {
                              handleSelectChange(selected, "institute");
                            }}
                            options={instituteOptions}
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="mb-3">
                          <Label>Job Post</Label>
                          <Select
                            name="job_post"
                            value={selectedJobpost}
                            onChange={(selected) => {
                              handleSelectChange(selected, "jobPost");
                            }}
                            options={jobpostOptions}
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="mb-3">
                          <Label>Candidate</Label>
                          <Select
                            name="candidate"
                            value={selectedCandidate}
                            onChange={(selected) => {
                              handleSelectChange(selected, "candidate");
                            }}
                            options={candidateOptions}
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="mb-3">
                          <Label>Source</Label>
                          <Select
                            options={[{ label: "Application", value: 0 }, { label: "Resume", value: 1 }]}
                            classNamePrefix="select2-selection"
                            onChange={(selected) => {
                              handleSelectChange(selected, "findresume");
                            }}
                            value={selectedSourse}
                          />
                        </div>
                      </Col>
                      <Col md="1" style={{ paddingTop: "4px" }}>
                        <div className="mt-4 mb-2">
                          <Button
                            color="danger"
                            type="reset"
                            onClick={() => reset()}
                          >
                            Reset
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <MDBDataTable
                        id="shortlistedApplicationTableID"
                        responsive
                        bordered
                        data={data}
                        searching={true}
                        info={false}
                        disableRetreatAfterSorting={true}
                        paging={false}
                        onSearch={(value) => setKeyword(value)}
                        entries={PerPageCount}
                      />
                      {totalPages > 20 && (
                        <div className="pagination-div">
                          <div className="page-details">
                            Showing {((currentPage - 1) * PerPageCount) + 1} to{" "}
                            {Math.min(currentPage * PerPageCount, totalPages)} of{" "}
                            {totalPages} entries
                          </div>
                          <Pagination
                            color="standard"
                            shape="rounded"
                            defaultPage={1}
                            count={Math.ceil(totalPages / PerPageCount)}
                            page={currentPage}
                            onChange={paginate}
                            size="large"
                          />
                        </div>
                      )}
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </div>
      </div>

    </React.Fragment>

  );
};


export default ShortlistedApplication;